import { DeviceOperationalState } from '@/__generated__/graphql';
import { useUpdateOperationalStateMutation } from '@features/changeOperationalState/hooks/useUpdateOperationalStateMutation';
import { zodResolver } from '@hookform/resolvers/zod';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

const schema = z.object({
  deviceId: z.string(),
  operationalState: z.nativeEnum(DeviceOperationalState).nullable(),
});

type FormValues = z.infer<typeof schema>;

export const useUpdateDeviceOperationalStateForm = (deviceId: string) => {
  const methods = useForm<FormValues>({
    defaultValues: { deviceId },
    resolver: zodResolver(schema),
  });

  const { reset } = methods;

  const { updateOperationalState: update, currentState } =
    useUpdateOperationalStateMutation(deviceId);

  const onSubmit = methods.handleSubmit(async (formData) => {
    if (!formData.operationalState) return;
    await update(formData.operationalState);
  });

  useEffect(() => {
    reset({ deviceId, operationalState: null });
  }, [currentState, reset, deviceId]);

  return {
    currentOperationalState: currentState,
    onSubmit,
    methods,
  };
};
